import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Trash, X } from "lucide-react";
import { deleteFile } from "@/core/api/api";
import useToastStore from "@/shared/zustand/toastStore";
import { isArtifactDataFilename } from "@/shared/utils/helpers";
export const FileDeleteConfirmationDialog = (props) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const showToast = useToastStore((state) => state.showToast);
    const handleDeleteFile = async () => {
        if (!props.projectId) {
            showToast("error", "Error", "No project selected for deletion of file");
            return;
        }
        if (!props.selectedFile || !props.selectedFile.url) {
            showToast("error", "Error", "No file selected for deletion");
            return;
        }
        setIsDeleting(true);
        // console.log("Deleting file:", props.selectedFile , props.projectId);
        try {
            const { responseData, error } = await deleteFile(props.projectId, props.selectedFile.url);
            if (error) {
                console.error("Error deleting file:", error);
                showToast("error", "Error", error.errorMessage);
                setIsDeleting(false);
                return;
            }
            showToast("success", "Success", "File deleted successfully!");
            props.onDeleteSuccess(); // Refresh the file list
            props.onHide(); // Close the dialog
        }
        catch (error) {
            console.error("Error deleting file:", error);
            showToast("error", "Error", "Failed to delete file");
        }
        finally {
            setIsDeleting(false);
        }
    };
    const footerContent = (_jsxs("div", { className: "flex justify-end gap-2", children: [_jsxs(Button, { onClick: props.onHide, className: "text-[#374151] text-sm ml-auto px-4 py-2 rounded-[6px] flex items-center gap-2 border border-[#D1D5DB]", disabled: isDeleting, children: [_jsx(X, { size: 16 }), _jsx("span", { children: "Cancel" })] }), _jsxs(Button, { onClick: handleDeleteFile, className: "rounded-[6px] px-4 py-2 text-sm text-white flex items-center gap-x-2 transition-all duration-300 bg-red-500", loading: isDeleting, children: [_jsx(Trash, { size: 16, color: "white" }), _jsx("span", { children: "Delete" })] })] }));
    return (_jsx(Dialog, { header: _jsx("h3", { className: "text-[#344054] text-lg font-semibold flex items-center gap-x-3", children: "Confirm Deletion" }), visible: props.visible, style: { width: "450px" }, onHide: props.onHide, footer: footerContent, blockScroll: true, appendTo: props.parentRef?.current, className: "max-w-[600px] font-content rounded-[8px] bg-[#fff] shadow-none border", maskClassName: "!absolute backdrop-blur-sm border border-[#d1d5db]", draggable: false, resizable: false, closable: !isDeleting, children: _jsxs("div", { className: "flex flex-col gap-3 p-3", children: [_jsxs("p", { className: "font-medium text-gray-700", children: ["Are you sure you want to delete the file", " ", _jsxs("span", { className: "font-bold text-gray-900", children: ["\"", isArtifactDataFilename(props.selectedFile?.name) ? props.selectedFile?.name?.replace(".json", "") : props.selectedFile?.name, "\""] }), "?"] }), _jsx("p", { className: "text-sm text-gray-600", children: "This action cannot be undone. The file will be permanently removed." })] }) }));
};
export default FileDeleteConfirmationDialog;
